import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { h5NavigateTo } from "../../utils/miniProgramEnv";
import { resolveAppMediaUrl } from "../../utils/resolveAppMediaUrl";
import { tryOpenH5ProductService } from "../product/SpaceProductSection";
import type { MembershipProduct } from "../SpaceType";
import { diamondEntranceIconUrl } from "../spacePageUtils";

const MAX_DIAMOND_ITEMS = 10;

/** 金刚区：展示 mobileEntrances.diamond 已启用的产品入口（最多 2 行 × 5 个） */
export function SpaceHomeDiamondZone(props: {
  spaceId: string;
  products: MembershipProduct[];
  isLoggedIn: boolean;
  onLoginRequest: () => void;
}) {
  const { spaceId, products, isLoggedIn, onLoginRequest } = props;
  const navigate = useNavigate();

  const items = useMemo(() => products.slice(0, MAX_DIAMOND_ITEMS), [products]);

  const onItemClick = useCallback(
    (row: MembershipProduct) => {
      const productId = row.spaceProductId?.trim();
      if (!productId) {
        return;
      }
      if (!isLoggedIn) {
        onLoginRequest();
        return;
      }
      if (!tryOpenH5ProductService(row)) {
        return;
      }
      h5NavigateTo(navigate, `/space/${spaceId}/${encodeURIComponent(productId)}`);
    },
    [isLoggedIn, navigate, onLoginRequest, spaceId]
  );

  if (items.length === 0) {
    return null;
  }

  return (
    <section className="space-home-feed__section space-home-diamond" aria-label="金刚区">
      <div className="space-home-diamond-grid" role="list">
        {items.map((row) => {
          const iconRaw = diamondEntranceIconUrl(row);
          const iconUrl = iconRaw ? resolveAppMediaUrl(iconRaw) : null;
          const label = row.displayName?.trim() || "产品";
          return (
            <button
              key={row.spaceProductId}
              type="button"
              className="space-home-diamond-item"
              role="listitem"
              onClick={() => onItemClick(row)}
            >
              <span className="space-home-diamond-icon-wrap">
                {iconUrl ? (
                  <img className="space-home-diamond-icon" src={iconUrl} alt="" loading="lazy" />
                ) : (
                  <span className="space-home-diamond-icon-fallback" aria-hidden>
                    {label.slice(0, 1)}
                  </span>
                )}
              </span>
              <span className="space-home-diamond-label">{label}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
